import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const PhoneField = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.Tel} field={FIELD_NAMES.PHONE} optional={optional} />;
};

PhoneField.propTypes = {
  optional: PropTypes.bool,
};
